export { NewResourceMapComponent } from './lib/components/new-resource-map/new-resource-map.component';
export { NewFloorplansMapComponent } from './lib/components/new-floorplans-map/new-floorplans-map.component';
